import React, { useState } from "react";
import { Box, Button, Collapse, Typography } from "@material-ui/core";
import { CollapseBody, CollapseHeader, CollapseHeaderInfo } from "./orderDetailsCollapseUser.style";
import { OrderDetailsItem } from "../item/orderDetailsItem";

import {
    KeyboardArrowDown as KeyboardArrowDownIcon,
    KeyboardArrowUp as KeyboardArrowUpIcon
} from '@material-ui/icons'
import formatPhone from "../../../../utils/formatPhone";


export const OrderDetailsCollapseUser = ({ order }) => {

    const [collapseIsopen, setCollapseIsOpen] = useState(false);

    return (
        <Box marginBottom='16px'>
            <CollapseHeader open={collapseIsopen}>
                <CollapseHeaderInfo justifyContent={order.modality === 'Delivery' ? 'space-between' : 'flex-start'}>
                    <OrderDetailsItem
                        style={{ marginRight: order.modality === 'Delivery' ? '0px' : '50px' }}
                        title='Nome'
                        label={order.user.name}
                    />
                    {
                        order.modality === 'Delivery' &&
                        (
                            <OrderDetailsItem
                                title='Endereço de entrega'
                                maxWidth='350px'
                                label={order.user.address ? order.user.address : 'Não informado'}
                                hasItalicLabel={!order.user.address}
                            />
                        )
                    }
                    {
                        order.user.phone && <OrderDetailsItem title='Telefone' label={formatPhone(order.user.phone)} />
                    }
                </CollapseHeaderInfo>
                <Box >
                    <Button
                        style={{ width: '137px', minWidth: '137px', justifyContent: 'flex-end' }}
                        onClick={() => setCollapseIsOpen(!collapseIsopen)}
                        endIcon={collapseIsopen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    >
                        <span style={{ fontSize: 10, textTransform: 'initial' }}>
                            {collapseIsopen ? 'Menos informações' : 'Mais informações'}
                        </span>
                    </Button>
                </Box>
            </CollapseHeader>
            <CollapseBody in={collapseIsopen}>
                <Box padding='12px 24px' display="flex" justifyContent="space-between">
                    <OrderDetailsItem title='Pedidos realizados' label={order.user.quantityOrders} />
                    <OrderDetailsItem title='Email' label={order.user.email} />
                    {
                        order.modality === 'Delivery' && (
                            <OrderDetailsItem
                                title='Endereço de entrega'
                                label={order.user.address ? order.user.address : 'Não informado'}
                                hasItalicLabel={!order.user.address}
                            />
                        )
                    }
                </Box>
            </CollapseBody>
        </Box>
    )
}
